const urlParams = new URLSearchParams(window.location.search);
const paramsToRemove = ['ref', 'sub_id', '_gl', 'srsltid'];
let hasParams = false;

paramsToRemove.forEach(param => {
  if (urlParams.has(param)) {

    localStorage.setItem(param, urlParams.get(param));
    hasParams = true;
  }
});

if (hasParams) {
  urlParams.forEach((value, key) => {
    if (paramsToRemove.includes(key)) urlParams.delete(key);
  });
  const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;

  window.location.replace(cleanUrl);
}
